import React from "react";
import { createLucideIcon, Shield, Wind, Link } from "lucide-react";

const HandFist = createLucideIcon("hand-fist", [
  ["path", { d: "M12.035 17.012a3 3 0 0 0-3-3l-.311-.002a.72.72 0 0 1-.505-1.229l1.195-1.195A2 2 0 0 1 10.828 11H12a2 2 0 0 0 0-4H9.243a3 3 0 0 0-2.122.879l-2.707 2.707A4.83 4.83 0 0 0 3 14a8 8 0 0 0 8 8h2a8 8 0 0 0 8-8V7a2 2 0 1 0-4 0v2a2 2 0 1 0 4 0", key: "a" }],
  ["path", { d: "M13.888 9.662A2 2 0 0 0 17 8V5A2 2 0 1 0 13 5", key: "b" }],
  ["path", { d: "M9 5A2 2 0 1 0 5 5V10", key: "c" }],
  ["path", { d: "M9 7V4A2 2 0 1 1 13 4V7.268", key: "d" }],
]);

const PlayingCards = createLucideIcon("playing-cards", [
  ["path", { d: "M14.832 8.445a1 1 0 00-1.589-.098l-2.075 3.098a1 1 0 000 1.11l2 3a1 1 0 001.664 0l2-3a1 1 0 000-1.11z", key: "a" }],
  ["path", { d: "m7.18 20.827-5-11a2 2 0 01.993-2.647L7 5.44", key: "b" }],
  ["rect", { x: "7", y: "2", width: "14", height: "20", rx: "2", key: "c" }],
]);

const CLASS_ICONS = { heavyweight: HandFist, middleweight: Shield, cruiserweight: Wind, tag_team: Link, wildcard: PlayingCards };

export function ClassIcon({ classId, color = "#FF007F", size = 12, className = "", testId }) {
  const Icon = CLASS_ICONS[classId] || HandFist;
  return (
    <Icon data-testid={testId} size={size} strokeWidth={2.6} className={`shrink-0 ${className}`}
          style={{ color, filter: `drop-shadow(0 0 3px ${color}) drop-shadow(0 0 6px ${color}88)` }} />
  );
}
